<template>
  <div class="body_show" v-if="body_show">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

    <div class="meacur_top">
      <h2>测评时间：{{data.ctime}} </h2>
    </div>
    <div class="meacur_main">
      <img src="@a/cp55_r2.png" alt="" class="me" />
      <div class="button_spe"><span>1</span>总体得分</div>
      <div class="me_mave">
        <h2>您的职业生涯信念得分如下： </h2>
        <div class="meacur_dv clearfix">
          <div class="dv_top dv_top1">
            <span></span>高分
          </div>
          <div class="dv_top dv_top2">
            <span></span>中间分
          </div>
          <div class="dv_top">
            <span></span>低分
          </div>
        </div>
        <h3 class="clearfix"><b class="pull-left">低分意义</b><b class="pull-right">高分意义</b></h3>
        <ul class="ul_t clearfix">
          <li v-for="(item,index) in result_list_lv" :key="index" class="clearfix">
            <div :class="['dv_left','clearfix',index==0?'dv_left1':'']">
              {{item.low}}<span>{{item.mark}}</span>
            </div>
            <div :class="['dv_right',index==0?'dv_right1':'',index==data.result_list.length-1?'dv_right2':'']">
              <h2 :class="{sum1: item.level=='M',sum2: item.level=='H'}" :style="{width: 0.96*item.score + 'rem'}"></h2>
              <dl :class="['clearfix',index==0?'dl1':'']">
                <dt></dt>
                <dt></dt>
                <dt></dt>
                <dt></dt>
                <dt></dt>
              </dl>
              <!-- <dl :class="['clearfix',index==0?'dl1':'']">
                <dt class="m1_dt"></dt>
                <dt class="m1_dt m1_dt1"></dt>
              </dl> -->
            </div>
            <div :class="['dv_left',index==0?'dv_left1':'','pull-right']">
              {{item.high}}
            </div>
          </li>
        </ul>
        <div class="dv_bottom">
          <ul class="clearfix">
            <li>0</li>
            <!-- <li class="b2">1.25</li>
            <li class="b4">3.75</li> -->
            <li class="b5">5</li>
          </ul>
        </div>
        <div class="score_group clearfix">
          <ul>
            <li v-for="(item,index) in data.result_list" :key="index">{{item.mark}}-{{item.division}}</li>
          </ul>
        </div>
        <div class="desc">您得分较高的方面是：
          <b v-for="(item,index) in data.high_desc" :key="index" v-show="data.high_desc.length>0"><span>{{item.division}}</span><i v-if="!(data.high_desc.length-1==index)">，</i></b>
          <span v-show="data.high_desc.length==0">无</span>
        </div>
        <div class="desc">您得分较低的方面是：
          <b v-for="(item,index) in data.low_desc" :key="index" v-show="data.low_desc.length>0"><span class="desc_sp1">{{item.division}}</span><i v-if="!(data.low_desc.length-1==index)">，</i></b>
          <span v-show="data.low_desc.length==0">无</span>
        </div>
      </div>
      <img src="@a/cp55_r4.png" alt="" class="me" />
      <div class="button_spe button_spe1">主要结论<span>2</span></div>
      <div class="clearfix"></div>
      <div class="me_mave me_mave1">
        <div class="mace_top">生涯信念得分较高或者较低可能都会使你的职业发展受到限制。
          <br/>您可能受到的限制如下：</div>
        <ul class="mace_ul" v-if="data.high_desc.length>0 || data.low_desc.length>0">
          <li v-for="(item,index) in data.high_desc" :key="index">
            <h5>{{item.division}}</h5>
            <h4>{{item.desc}}</h4>
          </li>
          <li v-for="(item,index) in data.low_desc" :key="index">
            <h5 class="mace_h5">{{item.division}}</h5>
            <h4>{{item.desc}}</h4>
          </li>
        </ul>
        <ul class="mace_ul" v-else>
          <li>
            <h4>您的生涯信念均处于相对合理水平。</h4>
          </li>
        </ul>
      </div>
      <img src="@a/cp55_r6.png" alt="" class="me" />
      <a class="reset" @click="reset">重新测评</a>
    </div>
    <!-- begin 插入广告组件 -->
    <public-advertising style="margin:25px 15px 0px;"></public-advertising>
    <public-ad-qrcode></public-ad-qrcode>
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p style="line-height: initial;">长按识别关注公众号<br/>回复“<font color="#f57f17">&nbsp;信念&nbsp;</font>”领取报告</p>
        <div class="text-center">
          <img class="qr-box" :src="data.qrcode" alt="" />
          <!-- <img class="qr-box" src="@a/ceping73/cp73-qrcode.jpg" alt="" /> -->
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  ceping55_report,
  ceping55_reset
} from "@/api/measurement";
import {
  shareCon
} from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";

import PublicAdvertising from "@c/measurement/public-advertising";
import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
  data() {
      return {
        body_show: false,
        report: false,
        data: {},
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: ""
        },
        result_list_lv: [],
        isShow: false
      }
    },
    components: {
      PublicAdvertising,
      PublicAdQrcode,
      PublicTopTips,
    },
    methods: {
      pullData() {
        ceping55_report({
            cid: this.$route.query.cid,
            uid: this.$route.query.uid
          })
          .then((data) => {
            if (data.code != '10002') {
              this.body_show = true;
              document.title = data.headtitle;
              this.data = data;
              if (data.need_subscribe && !this.data.subscribe) {
                this.isShow = true;
              };
              // 复制数组
              let arry = data.result_list.concat();
              // 数组倒序
              this.result_list_lv = arry.reverse();
              // 给分享js传值
              this.type_obj.evaluation_id = this.data.cid;
              this.type_obj.evaluation_name = data.headtitle;
              this.type_obj.evaluation_user_id = this.data.uid;
              this.type_obj.nickname = data.nickname;
              this.type_obj.path = this.$route.path;
              shareCon("measurement", this, this.type_obj);
            } else {
              this.$router.push('/ceping55')
            }
          })
      },
      reset() {
        ceping55_reset()
          .then((data) => {
            this.$router.push('/ceping55')
          })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss">
@import "@s/remChange.scss";
.body_show {
  padding-bottom: 30px;
  background-color: #fdf8df;
}

.men_detail {
  width: 100%;
  text-align: center;
  img {
    width: 100%;
  }
}

.men_foots {
  width: 100%;
  height: changeRem(1.96) + px;
  line-height: changeRem(1.96) + px;
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -375px;
  max-width: 750px;
  text-align: center;
  background: #EB5032;
  z-index: 2;
  color: #fff;
  font-size: changeRem(0.68) + px;
  a {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.meacur_top {
  background: url(../../../assets/cp55_r1.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: 472px;
  padding-top: 418px;
  text-align: center;
  h2 {
    font-size: 24px;
    color: #2C1B23;
  }
}

.meacur_main {
  margin-top: 48px;
  img.me {
    width: 100%;
  }
  .button_spe {
    background: url(../../../assets/cp55_r3.png) no-repeat top center;
    background-size: cover;
    height: 140px;
    width: 404px;
    line-height: 110px;
    color: #DF4248;
    font-size: 46px;
    padding: 0 28px;
    margin-top: 20px;
    span {
      font-size: 74px;
      margin-right: 54px;
      vertical-align: middle;
    }
  }
  .button_spe1 {
    background-image: url(../../../assets/cp55_r5.png);
    float: right;
    text-align: center;
    span {
      margin-right: 0;
      margin-left: 54px;
    }
  }
  .me_mave {
    margin-left: 30px;
    border-left: 12px solid #D33E44;
    padding: 80px 40px;
    h2 {
      text-align: center;
      font-size: 32px;
      color: #DF4248;
    }
    .meacur_dv {
      position: relative;
      width: 340px;
      text-align: center;
      margin: 0 auto;
      margin-top: 30px;
      .dv_top {
        position: absolute;
        right: 0;
        top: changeRem(.08) + px;
        font-size: 20px;
        color: #2C1B23;
        line-height: 0;
        span {
          display: inline-block;
          width: changeRem(.56) + px;
          height: changeRem(.24) + px;
          background: #D33E44;
          margin-right: changeRem(.2) + px;
          vertical-align: middle;
        }
      }
      .dv_top1 {
        right: changeRem(4.8) + px;
        span {
          background-color: #40ADAE;
        }
      }
      .dv_top2 {
        right: changeRem(2.2) + px;
        span {
          background-color: #2C1B23;
        }
      }
    }
    h3 {
      font-size: 22px;
      color: #2C1B23;
      margin-top: 142px;
    }
    ul.ul_t {
      margin-top: 40px;
      .dv_left {
        float: left;
        width: 140px;
        font-size: changeRem(.48) + px;
        text-align: left;
        height: changeRem(1.76) + px;
        span {
          float: right;
        }
      }
      .dv_right {
        width: 376px;
        float: left;
        margin-left: 4px;
        border-left: 2px solid #F57F17;
        position: relative;
        height: changeRem(1.76) + px;
        h2 {
          height: 28px;
          background: #D33E44;
          position: relative;
          z-index: 1;
        }
        h2.sum1 {
          background-color: #2C1B23;
        }
        h2.sum2 {
          background-color: #40ADAE;
        }
        dl {
          position: absolute;
          z-index: 0;
          top: 0;
          left: 0;
          dt {
            width: 73px;
            border-right: 2px dashed #eee;
            float: left;
            height: changeRem(1.72) + px;
          }
          dt.m1_dt {
            border-right-color: #F57F17;
            width: 90px;
          }
          dt.m1_dt1 {
            width: 182px;
          }
        }
        dl.dl1 {
          top: changeRem(.6) + px;
          dt {
            height: changeRem(2.04) + px;
          }
        }
      }
      .dv_left1 {
        height: changeRem(2.68) + px;
        padding-top: changeRem(.92) + px;
      }
      .pull-right {
        width: 100px;
        text-align: center;
      }
      .dv_right1 {
        height: changeRem(2.68) + px;
        padding-top: changeRem(.92) + px;
      }
      .dv_right2 {
        border-bottom: changeRem(.04) + px solid #F57F17;
      }
    }
    .dv_bottom {
      width: changeRem(9.6) + px;
      float: right;
      margin-top: changeRem(.2) + px;
      position: relative;
      li {
        margin-left: 0px;
        color: #333;
        font-size: changeRem(.44) + px;
        text-align: center;
        float: left;
      }
      li.b2 {
        margin-left: 50px;
      }
      li.b4 {
        margin-left: changeRem(2.65) + px;
      }
      li.b5 {
        // margin-left: 70px;
        float: right;
        margin-right: 110px;
      }
    }
    .score_group {
      width: 100%;
      background: rgba(238, 183, 64, 1);
      margin-top: 90px;
      padding-bottom: 42px;
      margin-bottom: 120px;
      li {
        margin: 42px;
        float: left;
        color: #2C1B23;
        font-size: 24px;
        margin-bottom: 0;
      }
    }
    .desc {
      margin-top: 60px;
      font-size: 28px;
      color: #2C1B23;
      b {
        font-weight: normal;
        span {
          color: #40ADAE;
          border-bottom: 2px solid #2C1B23;
          padding-bottom: 4px;
        }
        .desc_sp1 {
          color: #D33E44;
        }
      }
    }
  }
  .me_mave1 {
    margin-left: 0;
    border-left: none;
    margin-right: 30px;
    border-right: 12px solid #D33E44;
    .mace_top {
      line-height: 48px;
      font-size: 32px;
      color: #DF4248;
      text-align: justify;
    }
    .mace_ul {
      li {
        margin-top: 70px;
        h5 {
          color: #40ADAE;
          font-size: 28px;
        }
        .mace_h5 {
          color: #D33E44;
        }
        h4 {
          color: #2C1B23;
          font-size: 28px;
          line-height: 44px;
          margin-top: 10px;
          text-align: justify;
        }
      }
    }
  }
  .reset {
    display: block;
    margin: 0 auto;
    margin-top: 15px;
    background: url(../../../assets/cp55_r7.png) no-repeat top center;
    background-size: cover;
    width: 250px;
    height: 80px;
    line-height: 80px;
    color: #DF4248;
    font-size: 36px;
    text-align: center;
  }
}

.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}
</style>
